import { z } from "zod";

// SPEC-220 §4.1/§7: motivo del catálogo y detalle, ambos obligatorios. La
// pantalla no muestra un error por campo — muestra el único mensaje literal
// `REASON_REQUIRED` ("Indica el motivo y el detalle de la reversión") cuando
// falta cualquiera de los dos (RedemptionsPanel.tsx).
export const reverseRedemptionSchema = z.object({
  adjustmentReasonId: z.string().min(1),
  detail: z.string().trim().min(1),
});
export type ReverseRedemptionValues = z.infer<typeof reverseRedemptionSchema>;
